import { render } from "./Pagination.vue?vue&type=template&id=5eff77b9"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/sbimh.nl/tickets.sbimh.nl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__